document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('bundle-form');
  if (!root) return;

  const modal = root.querySelector('#bundle-set-modal');
  if (!modal) return;

  const parentForm = document.getElementById('bundle-parent-add-form');

  console.log('[Text Limitation] Initializing...');

  // The app's Font Type property NAME isn't consistent — Set 1 uses bare
  // "properties[Font Type]", Set 2's own "Back Embroidery" field calls it
  // "properties[Set 2: Back Font]" instead, and there's no telling what
  // other wording shows up elsewhere. Every one of them shares
  // class="pplr_font" regardless of name text though, so that's the
  // selector to key off, not the name attribute.
  const FONT_TYPE_SELECTOR = '.pplr_font';

  function fontTypeAttrSelector(extraAttr = '') {
    return `${FONT_TYPE_SELECTOR}${extraAttr}`;
  }

  const SCRIPT_TIP_TEXT =
    'The Script font does not support uppercase text. Uppercase entries are automatically converted to title case.';
  const PROFESSIONAL_TITLES = [
    // Prefixes
    'Mr',
    'Mr.',
    'Mrs',
    'Mrs.',
    'Ms',
    'Ms.',
    'Miss',
    'Mx',
    'Dr',
    'Dr.',
    'Prof',
    'Prof.',
    'Professor',
    'Sir',
    'Dame',
    'Lord',
    'Lady',
    'Rev',
    'Rev.',
    'Fr',
    'Fr.',
    'Br',
    'Br.',
    'Sr',
    'Sr.',
    'Rabbi',
    'Imam',
    'Atty',
    'Atty.',
    'Judge',
    'Hon',
    'Hon.',
    'Justice',
    'Engr',
    'Engr.',
    'Arch',
    'Arch.',

    // Medical
    'MD',
    'MD.',
    'DO',
    'DO.',
    'MBBS',
    'MBChB',
    'MBBCh',
    'PharmD',
    'RPh',
    'RPh.',
    'RN',
    'RN.',
    'LPN',
    'LPN.',
    'LVN',
    'LVN.',
    'NP',
    'NP.',
    'PA',
    'PA.',
    'PT',
    'PT.',
    'DPT',
    'OT',
    'OT.',
    'OTR',
    'DDS',
    'DDS.',
    'DMD',
    'DMD.',
    'DVM',
    'DVM.',
    'DC',
    'DC.',
    'OD',
    'OD.',
    'RD',
    'RD.',
    'RDN',
    'RT',
    'RT.',
    'RRT',

    // Academic
    'PhD',
    'PhD.',
    'DPhil',
    'EdD',
    'DBA',
    'DSc',
    'JD',
    'JD.',
    'LLB',
    'LLM',
    'SJD',
    'MBA',
    'MBA.',
    'EMBA',
    'MPA',
    'MPP',
    'MA',
    'MA.',
    'MS',
    'MS.',
    'MSc',
    'MEng',
    'MPhil',
    'BA',
    'BA.',
    'BS',
    'BS.',
    'BSc',
    'BEng',
    'BBA',

    // Engineering
    'PE',
    'PE.',
    'PEng',
    'CEng',
    'IEng',
    'EurIng',

    // Business
    'CPA',
    'CPA.',
    'CA',
    'CA.',
    'ACCA',
    'CMA',
    'CMA.',
    'CFA',
    'CFA.',
    'CFP',
    'CFP.',
    'CIA',
    'CIA.',
    'CISA',
    'CISM',
    'CFE',

    // IT
    'PMP',
    'PMP.',
    'CISSP',
    'CEH',
    'CCNA',
    'CCNP',
    'CCIE',
    'MCSE',
    'MCSD',
    'AWS',
    'RHCE',

    // Others
    'LPT',
    'LPT.',
    'RCh',
    'RCh.',
    'RPm',
    'RPm.',
    'RPsy',
    'RPsy.',
    'RMT',
    'RMT.',
    'PTRP',
    'RCrim',
    'RCrim.',

    // Generational suffixes
    'Jr',
    'Jr.',
    'II',
    'III',
    'IV',
  ];

  const TITLE_MAP = Object.fromEntries(PROFESSIONAL_TITLES.map((title) => [title.toLowerCase(), title]));

  function formatValue(value) {
    return value
      .split(/(\s+)/) // preserve whitespace
      .map((token) => {
        // Keep whitespace exactly as typed
        if (/^\s+$/.test(token)) {
          return token;
        }

        // Professional titles
        const title = TITLE_MAP[token.toLowerCase()];
        if (title) {
          return title;
        }

        // Preserve genuine mixed-case names (McDonald, MacArthur, iPhone) —
        // one optional leading capital, a run of lowercase, exactly one more
        // embedded capital, then lowercase to the end. Deliberately narrower
        // than "has both a lowercase and an uppercase letter somewhere" (the
        // old check) — that matched almost anything typed with stray caps
        // while Script-forced-uppercase was fighting the customer's actual
        // keystrokes (e.g. "ShEANEN", "LaYAGUIN"), so real garbled input was
        // being preserved as-is instead of getting title-cased like it should.
        // A trailing capital (PhD, RPh) never reaches this branch anyway —
        // those are already in PROFESSIONAL_TITLES and handled above.
        if (/^[A-Z]?[a-z]+[A-Z][a-z]+$/.test(token)) {
          return token;
        }

        // Preserve dotted abbreviations (M.D, D.D.S, U.S.A, etc.)
        if (/^[A-Za-z]{1,4}(\.[A-Za-z]{1,4})+\.?$/.test(token)) {
          return token.toUpperCase();
        }

        // Default Title Case
        return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
      })
      .join('');
  }

  function textLimitation(input) {
    const formatted = formatValue(input.value);

    if (formatted === input.value) return;

    console.log('[Text Limitation] Before:', input.value);
    console.log('[Text Limitation] After:', formatted);

    // formatValue() only ever rewrites the CASE of characters already there
    // (title-casing, uppercasing an abbreviation, etc.) — it never inserts or
    // removes any, for any token, so the string length is always unchanged.
    // That means the caret's numeric position from before the rewrite is still
    // valid after it, letting this run live while typing (see the 'input'
    // listener in initTextInput) without the caret jumping to the end.
    const { selectionStart, selectionEnd } = input;

    input.value = formatted;

    if (selectionStart !== null && selectionEnd !== null) {
      input.setSelectionRange(selectionStart, selectionEnd);
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getFontTypeInputs(pplrRoot) {
    return pplrRoot.querySelectorAll(fontTypeAttrSelector());
  }

  function isScriptValue(value) {
    return value.trim().toLowerCase() === 'script';
  }

  // The app numbers every field it renders sequentially as one continuous
  // "frame" count. Every rendered field (checkbox, dropdown, text input)
  // ends up carrying its OWN [data-main], not just the checkbox that starts
  // a feature group — so [data-main] alone can't be used as a group
  // boundary, it would put every field in its own single-frame "group" of
  // one. The real group boundaries are the paid add-on/set checkboxes
  // (input.pplrcheckbox) — a new group starts at each one and runs up to
  // (not including) the next. A single Font Type selector can govern
  // several text fields inside that same group at once (e.g. "My name" +
  // "Second line" under one "Add Name & Designation" group) — this finds
  // that group's frame range so pairing isn't limited to an exact frame
  // match, which only ever finds ONE field and silently leaves the rest of
  // a multi-field group unformatted.
  function getGroupFrameRange(pplrRoot, frame) {
    const frameNum = parseInt(frame, 10);
    const checkboxFrames = Array.from(pplrRoot.querySelectorAll('input.pplrcheckbox[data-frame]'))
      .map((el) => parseInt(el.dataset.frame, 10))
      .filter((num) => !Number.isNaN(num))
      .sort((a, b) => a - b);

    let start = -Infinity;
    let end = Infinity;

    for (const checkboxFrame of checkboxFrames) {
      if (checkboxFrame <= frameNum) {
        start = checkboxFrame;
      } else {
        end = checkboxFrame;
        break;
      }
    }

    return { start, end };
  }

  // Each text field also carries its own hidden, disabled duplicate Font
  // Type input at its own frame (the app's doing, not ours) — the real one
  // the customer actually sees and interacts with can sit at a neighboring
  // frame instead (e.g. one visible "Font Type" dropdown shared by both "My
  // name" and "Second line", with each field's own copy hidden). Reading
  // .value off the decoy isn't reliable since nothing confirms the app keeps
  // it in sync once hidden, so prefer whichever candidate is actually live.
  function isUsableFontTypeInput(input) {
    if (input.disabled) return false;

    const wrapper = input.closest('.pplr-wrapper');
    return !wrapper || window.getComputedStyle(wrapper).display !== 'none';
  }

  // The Product Personalizer app's fields (id="pplr-<product id>" and
  // everything inside it) are NOT DOM-nested inside <form id="bundle-parent-
  // add-form"> — they reach the form purely via each input's explicit
  // form="bundle-parent-add-form" attribute (see bundle-form.js's
  // findPersonalizerRoot comment). Pairing a Font Type input with its text
  // input(s) has to be scoped to the personalizer's own root div, not a form
  // ancestor — .closest('form...') would always return null here.
  function getGroupTextInputs(fontTypeInput) {
    const pplrRoot = fontTypeInput.closest('[id^="pplr-"]');
    const frame = fontTypeInput.dataset.frame;
    if (!pplrRoot || !frame) return [];

    const { start, end } = getGroupFrameRange(pplrRoot, frame);

    return Array.from(pplrRoot.querySelectorAll('.pplr_text')).filter((textInput) => {
      const textFrame = parseInt(textInput.dataset.frame, 10);
      return textFrame >= start && textFrame < end;
    });
  }

  function getGroupFontTypeInput(textInput) {
    const pplrRoot = textInput.closest('[id^="pplr-"]');
    const frame = textInput.dataset.frame;
    if (!pplrRoot || !frame) return null;

    const { start, end } = getGroupFrameRange(pplrRoot, frame);

    const candidates = Array.from(getFontTypeInputs(pplrRoot)).filter((fontTypeInput) => {
      const fontFrame = parseInt(fontTypeInput.dataset.frame, 10);
      return fontFrame >= start && fontFrame < end;
    });

    return candidates.find(isUsableFontTypeInput) || candidates[0] || null;
  }

  function ensureScriptTip(fontTypeInput) {
    const next = fontTypeInput.nextElementSibling;
    if (next && next.classList.contains('script-format-tip')) return next;

    const tip = document.createElement('em');
    tip.className = 'script-format-tip';
    tip.textContent = SCRIPT_TIP_TEXT;
    tip.style.display = 'none';
    tip.style.fontSize = '12px';
    fontTypeInput.insertAdjacentElement('afterend', tip);
    return tip;
  }

  function setScriptTipVisible(fontTypeInput, visible) {
    ensureScriptTip(fontTypeInput).style.display = visible ? '' : 'none';
  }

  function validateInput(input) {
    const fontTypeInput = getGroupFontTypeInput(input);
    if (!fontTypeInput || !isScriptValue(fontTypeInput.value)) return;

    textLimitation(input);
  }

  function initTextInput(input) {
    if (input.dataset.scriptValidationInitialized) return;

    input.dataset.scriptValidationInitialized = 'true';

    input.addEventListener('blur', () => {
      validateInput(input);
    });

    // The app forces the DISPLAYED text uppercase on every keystroke while
    // Script is selected (that's the whole reason this script exists) — the
    // rest of this file only corrects that on blur or via revalidateAll()'s
    // debounce, and revalidateAll() deliberately skips whichever field is
    // currently focused so it doesn't yank the caret out from under someone
    // typing elsewhere. Net effect: the field the customer is ACTUALLY typing
    // into never got corrected until they clicked away, so they'd watch their
    // own name build up in all-caps in real time. Now that textLimitation()
    // preserves the caret position (safe since it never changes string
    // length), this can run on every keystroke instead, live-correcting the
    // one field that's actually being typed into.
    input.addEventListener('input', () => {
      validateInput(input);
    });

    // The app resets this input's raw (pre-format) value whenever an unrelated
    // control anywhere in the form changes (Thread Color, Font Type, Name
    // Placement, etc.), undoing our formatting. Re-apply it whenever the value
    // is set programmatically...
    watchValueProperty(input, () => validateInput(input));

    // ...and also whenever the app fully re-renders the widget and replaces
    // this input with a brand-new node carrying the stale raw value baked in
    // (in which case there is no "set" for the watcher above to catch).
    validateInput(input);
  }

  const MAX_LENGTH_SELECTOR = 'input[maxlength="28"], input[data-maxlength="28"]';

  function getCharacterCounter(input) {
    const wrapper = input.closest('.pplr-wrapper') || input.parentElement;
    const frame = input.dataset.frame;
    if (!wrapper || !frame) return null;

    return wrapper.querySelector(`.pplr-character-count[data-frame="${CSS.escape(frame)}"]`);
  }

  function updateCharacterCount(input) {
    const counter = getCharacterCounter(input);
    if (!counter) return;

    const maxLength = Number(input.getAttribute('maxlength')) || Number(input.dataset.maxlength);
    if (!maxLength) return;

    const lm = counter.querySelector('.lm');
    if (lm) lm.textContent = ` / ${maxLength}`;

    const ct = counter.querySelector('.ct');
    if (ct) ct.textContent = String(Math.max(maxLength - input.value.length, 0));
  }

  function capMaxLength(input) {
    let changed = false;

    if (input.getAttribute('maxlength') === '28') {
      input.setAttribute('maxlength', '26');
      changed = true;
    }

    if (input.dataset.maxlength === '28') {
      input.dataset.maxlength = '26';
      changed = true;
    }

    if (changed) {
      updateCharacterCount(input);
    }
  }

  function applyMaxLengthCap(pplrRoot) {
    pplrRoot.querySelectorAll(MAX_LENGTH_SELECTOR).forEach(capMaxLength);
  }

  function watchValueProperty(el, onChange) {
    if (el.dataset.scriptValueWatched) return;
    el.dataset.scriptValueWatched = 'true';

    const descriptor =
      Object.getOwnPropertyDescriptor(el, 'value') ||
      Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), 'value');

    if (!descriptor || !descriptor.configurable) return;

    Object.defineProperty(el, 'value', {
      configurable: true,
      enumerable: descriptor.enumerable,
      get() {
        return descriptor.get.call(this);
      },
      set(newValue) {
        descriptor.set.call(this, newValue);
        onChange();
      },
    });
  }

  function observePersonalizerRoot(pplrRoot) {
    if (pplrRoot.dataset.scriptRootObserved) return;
    pplrRoot.dataset.scriptRootObserved = 'true';

    console.log('[Text Limitation] Observing personalizer root:', pplrRoot);

    pplrRoot.querySelectorAll('.pplr_text').forEach(initTextInput);
    applyMaxLengthCap(pplrRoot);

    // A native form reset (e.g. the app calling form.reset() from
    // updateconditionFeild when an unrelated field changes) restores every
    // form-associated input to its baked-in default value through the
    // browser's internal reset algorithm — including these, since they're
    // linked to the form via form="bundle-parent-add-form" even though not
    // DOM-nested in it — bypassing the value property setter entirely, so
    // watchValueProperty never fires. Catch it on the real form instead,
    // deferred a tick since fields haven't reset yet when it fires.
    if (parentForm) {
      parentForm.addEventListener('reset', () => {
        setTimeout(() => {
          pplrRoot.querySelectorAll('.pplr_text').forEach(validateInput);
        }, 0);
      });
    }

    // Every control in the personalizer (dropdown items, swatches, checkboxes,
    // color pickers, etc.) funnels into the app's own shared refresh routine,
    // which repaints fields from its own cached raw text - clobbering our
    // formatting regardless of which control triggered it. Re-validate on any
    // interaction inside the personalizer root, debounced so a burst of app
    // redraws only triggers one re-check. Skip the field currently focused so
    // this doesn't yank the cursor out from under someone actively typing.
    let revalidateTimer = null;
    const revalidateAll = () => {
      clearTimeout(revalidateTimer);
      revalidateTimer = setTimeout(() => {
        pplrRoot.querySelectorAll('.pplr_text').forEach((input) => {
          if (input === document.activeElement) return;
          validateInput(input);
        });
      }, 50);
    };

    pplrRoot.addEventListener('click', revalidateAll);
    pplrRoot.addEventListener('input', revalidateAll);
    pplrRoot.addEventListener('change', revalidateAll);

    // revalidateAll() above deliberately skips document.activeElement so a
    // burst of app redraws never yanks the cursor out from under someone mid-
    // keystroke — but clicking a font option (a plain, non-focusable <span>,
    // see the dropdown markup) doesn't blur the text field it's paired with.
    // So if the customer just typed a name and switches Block -> Script
    // without clicking away first, that field is STILL document.activeElement
    // and revalidateAll's guard silently skips reformatting it. Switching font
    // is a deliberate action, not a keystroke, so this listens for it directly
    // and always reformats regardless of focus — and reads the option's own
    // data-name instead of the hidden input's value, since it fires the instant
    // the app's onclick has run (target-phase handlers before bubble-phase),
    // sidestepping whatever timing/property-vs-attribute quirk the value-setter
    // watcher below might otherwise hit.
    pplrRoot.addEventListener('click', (event) => {
      const option = event.target.closest('.pplr-selecter-item[data-name]');
      if (!option) return;

      const frame = option.closest('[data-frame]')?.dataset.frame;
      if (!frame) return;

      const fontTypeInput = pplrRoot.querySelector(fontTypeAttrSelector(`[data-frame="${CSS.escape(frame)}"]`));
      if (!fontTypeInput) return;

      const textInputs = getGroupTextInputs(fontTypeInput);
      const primaryTextInput = textInputs[0] || null;
      if (!primaryTextInput) return;

      const isScript = option.dataset.name.trim().toLowerCase() === 'script';

      if (!/initials?/i.test(primaryTextInput.name)) {
        setScriptTipVisible(fontTypeInput, isScript);
      }

      if (isScript) textInputs.forEach(textLimitation);
    });

    const attachFontWatcher = (fontTypeInput) => {
      if (fontTypeInput.dataset.scriptWatcher) return;

      fontTypeInput.dataset.scriptWatcher = 'true';

      console.log('[Text Limitation] Watching Font Type:', fontTypeInput.name, fontTypeInput.dataset.frame);

      const handler = () => {
        console.log(
          '[Text Limitation] Font Type changed:',
          fontTypeInput.name,
          fontTypeInput.dataset.frame,
          fontTypeInput.value
        );

        const isScript = isScriptValue(fontTypeInput.value);
        const textInputs = getGroupTextInputs(fontTypeInput);
        const primaryTextInput = textInputs[0] || null;

        if (!primaryTextInput || !/initials?/i.test(primaryTextInput.name)) {
          setScriptTipVisible(fontTypeInput, isScript);
        }

        if (isScript) textInputs.forEach(textLimitation);
      };

      // The app (Zepto Product Personalizer) sets the hidden input's value
      // via its own JS (e.g. LoadPplrWithFont) without dispatching input/change
      // events, so we also intercept the value setter directly.
      watchValueProperty(fontTypeInput, handler);

      fontTypeInput.addEventListener('input', handler);
      fontTypeInput.addEventListener('change', handler);

      handler();
    };

    const attachFontWatchers = () => {
      getFontTypeInputs(pplrRoot).forEach(attachFontWatcher);
    };

    attachFontWatchers();

    // The app's field injection timing is opaque, and new Font Type/text
    // inputs land inside already-placed data-pplr-ph placeholders rather than
    // arriving as fresh top-level children (same behavior bundle-form.js's own
    // groupPplrFieldsBySet/syncPplrSetVisibility already accounts for) — so
    // watch this root's whole subtree and re-init/re-attach as needed.
    const observer = new MutationObserver((mutations) => {
      let shouldReattachWatchers = false;

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches('.pplr_text')) {
            initTextInput(node);
          }

          node.querySelectorAll?.('.pplr_text').forEach(initTextInput);

          if (node.matches(MAX_LENGTH_SELECTOR)) {
            capMaxLength(node);
          }

          node.querySelectorAll?.(MAX_LENGTH_SELECTOR).forEach(capMaxLength);

          // The personalization app may recreate Font Type inputs
          if (node.matches?.('input') || node.querySelector?.(fontTypeAttrSelector())) {
            shouldReattachWatchers = true;
          }
        }
      }

      if (shouldReattachWatchers) {
        attachFontWatchers();
      }
    });

    observer.observe(pplrRoot, {
      childList: true,
      subtree: true,
    });
  }

  function scanForPersonalizerRoots() {
    modal.querySelectorAll('[id^="pplr-"]').forEach(observePersonalizerRoot);
  }

  scanForPersonalizerRoots();

  // The Product Personalizer app injects its widget (id="pplr-<product id>")
  // asynchronously, sometime after this script runs — same assumption
  // bundle-form.js's own MutationObserver on `modal` already makes for
  // findPersonalizerRoot()/syncPplrSetVisibility().
  new MutationObserver(scanForPersonalizerRoots).observe(modal, {
    childList: true,
    subtree: true,
  });
});
